// extracted by mini-css-extract-plugin
export default {"dialog":"iB_BDrZ48QD7R_vcQnMO"};